
const getGeoZip = (geozipAuto: string | undefined, geozipApi: string | undefined) => {
  const defaultGeoZip = '28001'
  console.log(geozipAuto, geozipApi)
  let geoZip = defaultGeoZip
  if (geozipApi) {
    if (Number(geozipApi) < 52080 && Number(geozipApi) >= 1001) {
      geoZip = geozipApi
    }
  } else if (geozipAuto) {
    if (Number(geozipAuto) < 52080 && Number(geozipAuto) >= 1001) {
      geoZip = geozipAuto
    }
  }
  return geoZip
}

export default getGeoZip